<!-- Zweck: Stellt die HTML-Struktur für shop view article details component im Frontend bereit. -->
@if (!(article|async)) {
  <div>
    <div style="text-align: center; margin-top: 100px">
      <div style="display: inline-block">
        <mat-spinner></mat-spinner>
      </div>
      <div style="text-align: center">
        <h3>Lade Artikeldaten...</h3>
      </div>
    </div>
  </div>
}

@if ((article|async)) {
  <div>
    <section-title [hasBack]="true" [label]="(article|async)?.ArtikelName" [left_full_width]="true"
    icon="vorschau">
      <article-dtp-icon labelSuffix [isDtp]="(article|async)?.IstDtpArtikel"></article-dtp-icon>
    </section-title>
    <div class="articledetailsbox" [class.mobile]="msvc.isMobile()|async">
      <div>
        <div class="detailsboxinner mat-elevation-z1">
          <mat-toolbar>Details</mat-toolbar>
          @if ((msvc.isMobile()|async)) {
            <div class="paddedcontent detailscontentbox">
              <table style="width: 100%" class="table table-striped">
                @for (fieldname of renderFields; track fieldname) {
                  <tr>
                    <td style="vertical-align: top">
                      <b>
                        <view-field-label-render [fieldname]="fieldname" mode="box"></view-field-label-render>
                      </b>
                    </td>
                    <td style="vertical-align: top; white-space: normal; max-width: 400px">
                      <view-field-value-render [artikel]="article|async" [fieldname]="fieldname"
                      mode="box" [nowrap]="false"></view-field-value-render>
                    </td>
                  </tr>
                }
              </table>
            </div>
          }
          @if (!(msvc.isMobile()|async)) {
            <div class="paddedcontent detailscontentbox">
              <table style="width: 100%" class="table table-striped">
                @for (fieldname of renderFields1; track fieldname) {
                  <tr>
                    <td style="vertical-align: top">
                      <b>
                        <view-field-label-render [fieldname]="fieldname" mode="box"></view-field-label-render>
                      </b>
                    </td>
                    <td style="vertical-align: top; white-space: normal; max-width: 400px">
                      <view-field-value-render [artikel]="article|async" [fieldname]="fieldname" [nowrap]="false"
                      mode="box"></view-field-value-render>
                    </td>
                  </tr>
                }
              </table>
            </div>
          }
          @if (!(msvc.isMobile()|async)) {
            <div class="paddedcontent detailscontentbox">
              <table style="width: 100%" class="table table-striped">
                @for (fieldname of renderFields2; track fieldname) {
                  <tr>
                    <td style="vertical-align: top !important;">
                      <b>
                        <view-field-label-render [fieldname]="fieldname" mode="box"></view-field-label-render>
                      </b>
                    </td>
                    <td style="vertical-align: top; white-space: normal; max-width: 400px">
                      <view-field-value-render [artikel]="article|async" [fieldname]="fieldname" [nowrap]="false"
                      mode="box"></view-field-value-render>
                    </td>
                  </tr>
                }
              </table>
            </div>
          }
        </div>
        <feature-block [features]="['ArtikelEinkaufStatistik']" #artekstat>
          <permission-block [oneOfRoles]="['Statistiken - Artikel Einkaufsstatistik']" #artekstatperm>
            @if ((article|async) && (artekstat.visible|async) && (artekstatperm.visible|async)) {
              <div class="detailsboxinner ekstatbox mat-elevation-z1" [class.mobile]="msvc.isMobile()|async">
                <mat-toolbar>Einkaufsstatistik</mat-toolbar>
                <statistic-artikel-einkauf-view [artName]="(article|async)?.ArtikelName"
                  [artNr]="(article|async)?.ArtikelNummer"
                  [pzn]="(article|async)?.PZN"
                ></statistic-artikel-einkauf-view>
              </div>
            }
          </permission-block>
        </feature-block>
        @if (cfg.showShopAktionen(article|async) && (aktionen|async) && (aktionen|async)?.aktionen.length > 0) {
          <div class="detailsboxinner mat-elevation-z1">
            <mat-toolbar>Aktionen</mat-toolbar>
            <artikel-aktionen-details [aktionen]="aktionen|async"
              [directAddToWarenkorb]="!['NE', 'AV', 'NG'].includes((article|async)?.VerfuegbarkeitsstatusCode)">
            </artikel-aktionen-details>
          </div>
        }
        <div hasPermission [oneOfRoles]="['Dokumente Lieferschein', 'Dokumente Rechnung']" class="detailsboxinner">
          <mat-toolbar>Links</mat-toolbar>
          <div>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>Bezeichnung</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr hasPermission [oneOfRoles]="['Dokumente Lieferschein']">
                  <td>
                  </td>
                  <td>
                    Lieferscheine anzeigen
                  </td>
                  <td></td>
                  <td style="vertical-align: middle">
                    <a mat-icon-button
                      [routerLink]="'/analytics/documents/Lieferschein/search/L'+((article|async)?.ArtikelNummer)"
                      target="_blank">
                      <svg-icon>vorschau</svg-icon>
                    </a>
                  </td>
                </tr>
                <tr hasPermission [oneOfRoles]="['Dokumente Rechnung']">
                  <td>
                  </td>
                  <td>
                    Einzelrechnungen anzeigen
                  </td>
                  <td></td>
                  <td style="vertical-align: middle">
                    <a mat-icon-button
                      [routerLink]="'/analytics/documents/Einzelrechnung/search/L'+((article|async)?.ArtikelNummer)"
                      target="_blank">
                      <svg-icon>vorschau</svg-icon>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        @if ((article|async)?.infos.length > 0 || ((FeatureArtikelinfosBASGFachinformationen||FeatureArtikelinfosBASGGebrauchsinformationen) && (article|async)?.ArtikelZulassungsnummer && (article|async)?.ArtikelZulassungsnummer.trim() != '')) {
          <div
            class="detailsboxinner">
            <mat-toolbar>Produkt Informationen</mat-toolbar>
            <div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th>Bezeichnung</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @if (FeatureArtikelinfosBASGGebrauchsinformationen && (article|async)?.ArtikelZulassungsnummer && (article|async)?.ArtikelZulassungsnummer.trim() != '') {
                    <tr>
                      <td>
                        <img height="25" src="assets/fileicons/{{prettyFileIcons.getIcon('tttt.pdf', 'svg')}}"/>
                      </td>
                      <td>
                        BASG Gebrauchsinformation
                        <br>
                          <small>(Versucht Download von BASG.GV.AT)</small>
                        </td>
                        <td></td>
                        <td>
                          <a mat-icon-button
                            href="https://aspregister.basg.gv.at/document/servlet?action=show&zulnr={{(article|async)?.ArtikelZulassungsnummer|RemoveLeadingZero}}&type=DOTC_GEBR_INFO"
                            target="_blank">
                            <svg-icon>downloads</svg-icon>
                          </a>
                        </td>
                      </tr>
                    }
                    @if (FeatureArtikelinfosBASGFachinformationen && (article|async)?.ArtikelZulassungsnummer && (article|async)?.ArtikelZulassungsnummer.trim() != '') {
                      <tr>
                        <td>
                          <img height="25" src="assets/fileicons/{{prettyFileIcons.getIcon('tttt.pdf', 'svg')}}"/>
                        </td>
                        <td>
                          BASG Fachinformation
                          <br>
                            <small>(Versucht Download von BASG.GV.AT)</small>
                          </td>
                          <td>
                          </td>
                          <td>
                            <a mat-icon-button
                              href="https://aspregister.basg.gv.at/document/servlet?action=show&zulnr={{(article|async)?.ArtikelZulassungsnummer|RemoveLeadingZero}}&type=DOTC_FI_INFO"
                              target="_blank">
                              <svg-icon>downloads</svg-icon>
                            </a>
                          </td>
                        </tr>
                      }
                      @for (info of (article|async)?.infos; track info) {
                        <tr>
                          <td>
                            @if (info.file) {
                              <img height="25"
                                src="assets/fileicons/{{prettyFileIcons.getIcon(info.file.filename+'.'+info.file.extension, 'svg')}}"/>
                            }
                            @if (!info.file) {
                              <img height="25"
                                src="assets/fileicons/{{prettyFileIcons.getIcon('text.txt', 'svg')}}"/>
                            }
                          </td>
                          <td>
                            {{info.label}}
                          </td>
                          <td>
                            @if (info.file) {
                              <span>
                                {{info.file.size|filesize}}
                              </span>
                            }
                          </td>
                          <td>
                            <button mat-icon-button routerLink="./informations/{{info.id}}">
                              <svg-icon>vorschau</svg-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
          <div style="text-align: center;">
            <div style="display: inline-block; background-color: white; margin-top: 20px; padding: 5px" class="mat-elevation-z1">
              @if ((article|async) && view && slug) {
                <shop-view-action [artikel]="article|async" [view]="view"
                [inDetailsView]="true"></shop-view-action>
              }
            </div>
          </div>
        </div>
        @if ((zubehoer|async)?.length > 0) {
          <div class="zubehboxrow mat-elevation-z1">
            <mat-toolbar>Zubehör</mat-toolbar>
            <owl-carousel-o [options]="carouselOptions">
              @for (zubeh of zubehoer|async; track zubeh) {
                <ng-template carouselSlide>
                  <div class="image">
                    <div class="zubehbox mat-elevation-z1">
                      <div class="titlebox">
                        <div class="underlined">
                          <a routerLink="/shop/{{slug}}/{{zubeh.ZubehoerArtikel.ArtikelNummer}}">
                            <strong>{{zubeh.ZubehoerArtikel.ArtikelName}}</strong> <article-dtp-icon [isDtp]="zubeh.ZubehoerArtikel.IstDtpArtikel"></article-dtp-icon>
                          </a>
                        </div>
                      </div>
                      <div class="zubehboxinner paddedcontent">
                        @if (zubeh.ZubehoerBeschreibung) {
                          <div>{{zubeh.ZubehoerBeschreibung}}</div>
                        }
                        <table style="width: 100%">
                          @for (fieldname of zubhfield; track fieldname) {
                            <tbody>
                              @if (fieldname != 'ArtikelName') {
                                <tr>
                                  <td>
                                    <b>
                                      <view-field-label-render [fieldname]="fieldname" mode="box"></view-field-label-render>
                                    </b>
                                  </td>
                                  <td>
                                    <view-field-value-render [artikel]="zubeh.ZubehoerArtikel" [fieldname]="fieldname" [nowrap]="false"
                                    mode="box"></view-field-value-render>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          }
                          <tbody>
                            <tr>
                              <td colspan="2" style="text-align: center; background-color: white">
                                @if (slug && view) {
                                  <shop-view-action [artikel]="zubeh.ZubehoerArtikel" [view]="view"
                                  [inDetailsView]="true"></shop-view-action>
                                }
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </ng-template>
              }
            </owl-carousel-o>
          </div>
        }
      </div>
    }
